import { SOURCE_DEFAULTS } from "../sources/index.js";
import { buildQueryUrl } from "./endpoints.js";
import { requestWithParameters } from "./request-with-parameters.js";
export const query = async function (options) {
    const { apiBaseUrl = SOURCE_DEFAULTS.apiBaseUrl, clientId = SOURCE_DEFAULTS.clientId, maxLengthURL = SOURCE_DEFAULTS.maxLengthURL, connectionName, sqlQuery, queryParameters } = options;
    const urlParameters = { q: sqlQuery };
    if (queryParameters) {
        urlParameters.queryParameters = JSON.stringify(queryParameters);
    }
    const baseUrl = buildQueryUrl({ apiBaseUrl, connectionName });
    const headers = { Authorization: `Bearer ${options.accessToken}`, ...options.headers };
    const parameters = { client: clientId, ...urlParameters };
    const errorContext = {
        requestType: 'SQL',
        connection: options.connectionName,
        type: 'query',
        source: JSON.stringify(parameters, undefined, 2)
    };
    return await requestWithParameters({
        baseUrl,
        parameters,
        headers,
        errorContext,
        maxLengthURL
    });
};
